import { createSlice ,createAsyncThunk} from "@reduxjs/toolkit";
import hrService from "./hrService";
const HR = JSON.parse(localStorage.getItem('hr'))
const initialState = {
    HR : HR ? HR : null,
    isLoading : false,
    isError : false,
    isSuccess : false,
    message : ''
}
const HRSlice = createSlice({
   name : 'hr',
   initialState,
   reducers : {
    reset : (state)=>{
        state.isError = false
        state.isLoading = false
        state.isSuccess = false 
        state.message = ""
    },
   },
   
   extraReducers : (builder)=>{
    builder
    .addCase(HRLogin.pending,(state,action)=>{
        state.isLoading = true
    })
    .addCase(HRLogin.fulfilled,(state,action)=>{
        state.isLoading = false
        state.isError = false
        state.isSuccess = true
        state.message = ''
        state.HR = action.payload
    })
    .addCase(HRLogin.rejected,(state,action)=>{
        state.isLoading = false
        state.isError = true
        state.isSuccess = false
        state.message = action.payload
        state.HR = ''
    })
    .addCase(HRLogout.fulfilled,(state,action)=>{
        state.HR = null
    })
   }
})

export const HRLogin =  createAsyncThunk('HR/Login',async(HRDetails , thunkAPI)=>{
    try {
       return await hrService.HRLogin(HRDetails)
    } catch (error) {
        const message  = (error.response &&  error.response.data && error.response.data.message || error.message || error.toString() )
        return thunkAPI.rejectWithValue(message)
    }
})

export const HRLogout =  createAsyncThunk('HR/Logout',async()=>{
    return await hrService.HRLogout()
})
export default HRSlice.reducer
export const {reset} = HRSlice.actions